import { render, staticRenderFns } from "./ActivateAccountOnForgotAC.vue?vue&type=template&id=5820e594"
import script from "./ActivateAccountOnForgotAC.vue?vue&type=script&lang=js"
export * from "./ActivateAccountOnForgotAC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports